<template>
    <div class="relative h-[152px] bg-[#1f1f1f] rounded-[0.8rem]">
        <iframe
            :title="id"
            :src="`https://open.spotify.com/embed/album/${id}?utm_source=generator&theme=0`"
            width="100%"
            height="152"
            style="border-radius:0"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
        />
    </div>
</template>

<script>
    // Library
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'SpotifyPlayer',

        props: {
            id: {
                type: String,
                required: true,
            },
        },
    });
</script>
